import { PAGES } from "@/internals/constants/pages";
import { StatsFormFields } from "./stats-block";
import { FACILITIES } from "@/data/shared/facilities";

const structure = {
  page: PAGES.QR_BUSINESS,
  metaTitle: "meta_title",
  metaDescription: "meta_description",
  title: "title",
  formFields: [
    {
      component: "Accordion",
      title: "name_title",
      className: "qrForm",
      formFields: [
        {
          component: "InputLib",
          type: "text",
          placeholder: "qr_name_placeholder",
          errorMessage: [{ rule: "maxLength", message: "qr_name_maximum_length" }],
          name: "qrName",
          data_qa: "qr-business-name-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "theme_picker_title",
      formFields: [
        {
          component: "ThemePicker",
          labelPrimary: "theme_picker_label_primary",
          labelSecondary: "theme_picker_label_secondary",
          id: "qrBusinessThemePicker",
          name: "themeColor",
          data_qa: "qr-business-theme-picker",
        },
      ],
    },
    {
      component: "Accordion",
      title: "information_title",
      id: "qrbusinessInformation",
      className: "qrbusinessInformation",
      formFields: [
        {
          component: "div",
          className: "u-flex-full",
          formFields: [
            {
              component: "ImageUpload",
              title: "qr_logo_title",
              id: "qrBusinessInformationLogo",
              showEditor: "16/9",
              name: "logoUrl",
              data_qa: "qr-business-logo-image-upload",
            },
          ],
        },
        {
          component: "InputLib",
          type: "text",
          label: "company_name_label",
          placeholder: "company_name_placeholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "company_name_maximum_length",
            },
          ],
          name: "companyName",
          data_qa: "qr-business-company-name-input",
        },
        {
          component: "InputLib",
          type: "text",
          label: "title_label",
          placeholder: "title_placeholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "company_name_maximum_length",
            },
          ],
          name: "title",
          data_qa: "qr-business-title-input",
        },
        {
          component: "InputLib",
          type: "text",
          label: "subtitle_label",
          placeholder: "subtitle_placeholder",
          name: "subtitle",
          data_qa: "qr-business-subtitle-input",
        },
        {
          component: "div",
          className: "button-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "button_label",
              placeholder: "button_placeholder",
              errorMessage: [{ rule: "maxLength", message: "button_max_length" }],
              name: "buttonText",
              data_qa: "qr-business-button-text-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "url_label",
              placeholder: "url_placeholder",
              errorMessage: [{ rule: "pattern", message: "invalid_link" }],
              name: "buttonUrl",
              data_qa: "qr-business-button-url-input",
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "opening_hours_title",
      className: "opening-hours",
      formFields: [
        {
          component: "BusinessHours",
          id: "businessHours",
          name: "businessHours",
        },
      ],
    },
    {
      component: "Accordion",
      title: "location_title",
      className: "location",
      formFields: [
        {
          component: "div",
          className: "address-numeration-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "address_label",
              placeholder: "address_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "address_maximum_length",
                },
              ],
              name: "address",
              data_qa: "qr-business-address-input",
            },
            {
              component: "div",
              className: "numeration-wrapper",
              formFields: [
                {
                  component: "InputLib",
                  type: "text",
                  label: "numeration_label",
                  placeholder: "numeration_placeholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "numeration_maximum_length",
                    },
                  ],
                  name: "numeration",
                  data_qa: "qr-business-numeration-input",
                },
                {
                  component: "InputLib",
                  type: "text",
                  label: "zip_code_label",
                  placeholder: "zip_code_placeholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "zip_code_maximum_length",
                    },
                  ],
                  name: "zipCode",
                  data_qa: "qr-business-zip-code-input",
                },
              ],
            },
          ],
        },
        {
          component: "div",
          className: "address-state",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "city_label",
              placeholder: "city_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "city_maximum_length",
                },
              ],
              name: "city",
              data_qa: "qr-business-city-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "state_label",
              placeholder: "state_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "state_maximum_length",
                },
              ],
              name: "state",
              data_qa: "qr-business-state-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "country_label",
              placeholder: "country_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "country_maximum_length",
                },
              ],
              name: "country",
              data_qa: "qr-business-country-input",
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "facilities_title",
      className: "qrBusinessFacilities",
      formFields: [
        {
          component: "Picker",
          id: "facilitiesPicker",
          multiple: true,
          className: "Picker__list-background",
          options: FACILITIES,
          name: "facilities",
          data_qa: "qr-business-name-picker",
          selector: "icon",
        },
      ],
    },
    {
      component: "Accordion",
      title: "contact_title",
      className: "businessContactInfo",
      formFields: [
        {
          component: "div",
          className: "name-phone-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "name_label",
              placeholder: "name_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "name_maximum_length",
                },
              ],
              name: "contactName",
              data_qa: "qr-business-contact-name-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "phone_label",
              placeholder: "phone_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "phone_maximum_length",
                },
              ],
              name: "contactPhone",
              data_qa: "qr-business-contact-phone-input",
            },
          ],
        },
        {
          component: "div",
          className: "email-website-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "email_label",
              placeholder: "email_placeholder",
              errorMessage: [{ rule: "pattern", message: "invalid_email" }],
              name: "contactEmail",
              data_qa: "qr-business-contact-email-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "website_label",
              placeholder: "website_placeholder",
              errorMessage: [{ rule: "pattern", message: "invalid_link" }],
              name: "contactWebsite",
              data_qa: "qr-business-contact-website-input",
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "about_company_title",
      className: "about",
      formFields: [
        {
          component: "TextAreaLib",
          resize: "none",
          placeholder: "about_company_placeholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "about_company_maximum_length",
            },
          ],
          name: "aboutTheCompany",
          data_qa: "qr-business-company-about-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "socials_title",
      formFields: [
        {
          component: "ListPicker",
          id: "qrBusinessSocials",
          title: "socials_title_multiple",
          titleEmpty: "socials_title_empty",
          name: "socialNetworks",
          data_qa: "qr-business-socials-list-picker",
          options: [
            {
              id: "facebook",
              name: "Facebook",
              value: "",
              data_qa: "facebook-button",
              placeholder: "https://facebook.com/profile",
              tooltip: { text: "Facebook", position: "top" },
            },
            {
              id: "instagram",
              name: "Instagram",
              value: "",
              data_qa: "instagram-button",
              placeholder: "https://instagram.com/profile",
              tooltip: { text: "Instagram", position: "top" },
            },
            {
              id: "threads",
              name: "Threads",
              value: "",
              data_qa: "threads-button",
              placeholder: "https://threads.com/profile",
              tooltip: { text: "Threads", position: "top" },
            },
            {
              id: "tiktok",
              name: "Tiktok",
              value: "",
              data_qa: "tiktok-button",
              placeholder: "https://tiktok.com/profile",
              tooltip: { text: "Tiktok", position: "top" },
            },
            {
              id: "x",
              name: "X",
              value: "",
              data_qa: "x-button",
              placeholder: "https://x.com/profile",
              tooltip: { text: "X", position: "top" },
            },
            {
              id: "reddit",
              name: "Reddit",
              value: "",
              data_qa: "reddit-button",
              placeholder: "https://reddit.com/profile",
              tooltip: { text: "Reddit", position: "top" },
            },
            {
              id: "nextdoor",
              name: "Nextdoor",
              value: "",
              data_qa: "nextdoor-button",
              placeholder: "https://nextdoor.com/profile",
              tooltip: { text: "Nextdoor", position: "top" },
            },
            {
              id: "tumblr",
              name: "Tumblr",
              value: "",
              data_qa: "tumblr-button",
              placeholder: "https://tumblr.com/profile",
              tooltip: { text: "Tumblr", position: "top" },
            },
            {
              id: "behance",
              name: "Behance",
              value: "",
              data_qa: "behance-button",
              placeholder: "https://behance.net/profile",
              tooltip: { text: "Behance", position: "top" },
            },
            {
              id: "bluesky",
              name: "Bluesky",
              value: "",
              data_qa: "bluesky-button",
              placeholder: "https://blueskyweb.xyz/profile",
              tooltip: { text: "Bluesky", position: "top" },
            },
            {
              id: "mastodon",
              name: "Mastodon",
              value: "",
              data_qa: "mastodon-button",
              placeholder: "https://mastodon.social/profile",
              tooltip: { text: "Mastodon", position: "top" },
            },
            {
              id: "vkontakte",
              name: "Vkontakte",
              value: "",
              data_qa: "vkontakte-button",
              placeholder: "https://vk.com/profile",
              tooltip: { text: "Vkontakte", position: "top" },
            },
            {
              id: "facebookMessenger",
              name: "Messenger",
              value: "",
              data_qa: "facebook-messenger-button",
              placeholder: "https://m.me/profile",
              tooltip: { text: "Messenger", position: "top" },
            },
            {
              id: "whatsapp",
              name: "WhatsApp",
              value: "",
              data_qa: "whatsapp-button",
              placeholder: "https://wa.me/1234567890",
              tooltip: { text: "WhatsApp", position: "top" },
            },
            {
              id: "microsoftTeams",
              name: "Microsoft Teams",
              value: "",
              data_qa: "microsoft-teams-button",
              placeholder: "https://teams.microsoft.com/l/profile",
              tooltip: { text: "Microsoft Teams", position: "top" },
            },
            {
              id: "discord",
              name: "Discord",
              value: "",
              data_qa: "discord-button",
              placeholder: "https://discord.com/invite/code",
              tooltip: { text: "Discord", position: "top" },
            },
            {
              id: "skype",
              name: "Skype",
              value: "",
              data_qa: "skype-button",
              placeholder: "https://skype.com/profile",
              tooltip: { text: "Skype", position: "top" },
            },
            {
              id: "telegram",
              name: "Telegram",
              value: "",
              data_qa: "telegram-button",
              placeholder: "https://t.me/profile",
              tooltip: { text: "Telegram", position: "top" },
            },
            {
              id: "line",
              name: "Line",
              value: "",
              data_qa: "line-button",
              placeholder: "https://line.me/profile",
              tooltip: { text: "Line", position: "top" },
            },
            {
              id: "snapchat",
              name: "Snapchat",
              value: "",
              data_qa: "snapchat-button",
              placeholder: "https://snapchat.com/profile",
              tooltip: { text: "Snapchat", position: "top" },
            },
            {
              id: "youtube",
              name: "YouTube",
              value: "",
              data_qa: "youtube-button",
              placeholder: "https://youtube.com/profile",
              tooltip: { text: "YouTube", position: "top" },
            },
            {
              id: "spotify",
              name: "Spotify",
              value: "",
              data_qa: "spotify-button",
              placeholder: "https://spotify.com/profile",
              tooltip: { text: "Spotify", position: "top" },
            },
            {
              id: "appleMusic",
              name: "Apple Music",
              value: "",
              data_qa: "apple-music-button",
              placeholder: "https://music.apple.com/profile",
              tooltip: { text: "Apple Music", position: "top" },
            },
            {
              id: "twitch",
              name: "Twitch",
              value: "",
              data_qa: "twitch-button",
              placeholder: "https://twitch.tv/profile",
              tooltip: { text: "Twitch", position: "top" },
            },
            {
              id: "soundcloud",
              name: "SoundCloud",
              value: "",
              data_qa: "soundcloud-button",
              placeholder: "https://soundcloud.com/profile",
              tooltip: { text: "SoundCloud", position: "top" },
            },
            {
              id: "vimeo",
              name: "Vimeo",
              value: "",
              data_qa: "vimeo-button",
              placeholder: "https://vimeo.com/profile",
              tooltip: { text: "Vimeo", position: "top" },
            },
            {
              id: "onlyfans",
              name: "OnlyFans",
              value: "",
              data_qa: "onlyfans-button",
              placeholder: "https://onlyfans.com/profile",
              tooltip: { text: "OnlyFans", position: "top" },
            },
            {
              id: "flickr",
              name: "Flickr",
              value: "",
              data_qa: "flickr-button",
              placeholder: "https://flickr.com/profile",
              tooltip: { text: "Flickr", position: "top" },
            },
            {
              id: "dribbble",
              name: "Dribbble",
              value: "",
              data_qa: "dribbble-button",
              placeholder: "https://dribbble.com/profile",
              tooltip: { text: "Dribbble", position: "top" },
            },
            {
              id: "pinterest",
              name: "Pinterest",
              value: "",
              data_qa: "pinterest-button",
              placeholder: "https://pinterest.com/profile",
              tooltip: { text: "Pinterest", position: "top" },
            },
            {
              id: "linkedin",
              name: "Linkedin",
              value: "",
              data_qa: "linkedin-button",
              placeholder: "https://linkedin.com/profile",
              tooltip: { text: "Linkedin", position: "top" },
            },
            {
              id: "github",
              name: "Github",
              value: "",
              data_qa: "github-button",
              placeholder: "https://github.com/profile",
              tooltip: { text: "Github", position: "top" },
            },
            {
              id: "quora",
              name: "Quora",
              value: "",
              data_qa: "quora-button",
              placeholder: "https://quora.com/profile",
              tooltip: { text: "Quora", position: "top" },
            },
            {
              id: "xing",
              name: "Xing",
              value: "",
              data_qa: "xing-button",
              placeholder: "https://xing.com/profile",
              tooltip: { text: "Xing", position: "top" },
            },
            {
              id: "googleReviews",
              name: "Google Reviews",
              value: "",
              data_qa: "google-reviews-button",
              placeholder: "https://business.google.com/profile",
              tooltip: { text: "Google Reviews", position: "top" },
            },
            {
              id: "yelp",
              name: "Yelp",
              value: "",
              data_qa: "yelp-button",
              placeholder: "https://yelp.com/profile",
              tooltip: { text: "Yelp", position: "top" },
            },
            {
              id: "tripadvisor",
              name: "Tripadvisor",
              value: "",
              data_qa: "tripadvisor-button",
              placeholder: "https://tripadvisor.com/profile",
              tooltip: { text: "Tripadvisor", position: "top" },
            },
            {
              id: "uberEats",
              name: "Uber Eats",
              value: "",
              data_qa: "uber-eats-button",
              placeholder: "https://ubereats.com/profile",
              tooltip: { text: "Uber Eats", position: "top" },
            },
            {
              id: "web",
              name: "Web",
              value: "",
              data_qa: "web-button",
              placeholder: "https://web.com/profile",
              tooltip: { text: "Web", position: "top" },
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "stats_title",
      subtitle: "stats_subtitle",
      className: "qrForm",
      formFields: StatsFormFields(),
    },
  ],
  layoutTranslations: {
    businessPreviewOpeningHours: "preview_opening_hours",
    businessPreviewOpeningHoursMonday: "preview_opening_hours_monday",
    businessPreviewOpeningHoursTuesday: "preview_opening_hours_tuesday",
    businessPreviewOpeningHoursWednesday: "preview_opening_hours_wednesday",
    businessPreviewOpeningHoursThursday: "preview_opening_hours_thursday",
    businessPreviewOpeningHoursFriday: "preview_opening_hours_friday",
    businessPreviewOpeningHoursSaturday: "preview_opening_hours_saturday",
    businessPreviewOpeningHoursSunday: "preview_opening_hours_sunday",
    businessPreviewLocation: "preview_location",
    businessPreviewZipCode: "preview_zip_code",
    businessPreviewName: "preview_name",
    businessPreviewPhone: "preview_phone",
    businessPreviewEmail: "preview_email",
    businessPreviewWebsite: "preview_website",
    businessPreviewFacilities: "preview_facilities",
    businessPreviewContactInformation: "preview_contact_information",
    businessPreviewAboutTheCompany: "preview_about_the_company",
    businessPreviewSocialNetworks: "preview_social_networks",
  },
};

export default structure;
